import { render, staticRenderFns } from "./TrackBadge.vue?vue&type=template&id=83d0e5d4"
import script from "./TrackBadge.vue?vue&type=script&lang=ts"
export * from "./TrackBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports